module.exports = __webpack_public_path__ + "static/media/home_tunnel_1.5d8c2617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_tunnel_1.png
// module id = 112
// module chunks = 0